import script from "./addCardsOrClass.vue?vue&type=script&setup=true&lang=js"
export * from "./addCardsOrClass.vue?vue&type=script&setup=true&lang=js"

import "./addCardsOrClass.vue?vue&type=style&index=0&id=6f188bf5&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f188bf5"]])

export default __exports__